import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTooltipModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ContactBaselineComponent } from './contact-baseline.component';

@NgModule({
	declarations: [ContactBaselineComponent],
	imports: [CommonModule, TranslateModule.forChild(), FreudTooltipModule],
	exports: [ContactBaselineComponent],
	providers: [],
})
export class ContactBaselineModule {}
